import type { ReapproAlgorithm } from '@gozoki/api-types'
import { useForm } from 'react-hook-form'

export interface ReapproAlgorithmsFormValues {
  algorithms: Record<string, ReapproAlgorithm>
}

export const useReapproAlgorithmMatrixForm = () =>
  useForm<ReapproAlgorithmsFormValues>({
    defaultValues: { algorithms: {} },
  })
